@if(invoiceDialog.show) {
<div style="width:'25rem'; max-height: 95vh; overflow-y: auto;margin: 0; padding: 0;" #invoiceCont>
  @for (type of updateInvoiceType; track $index) {
  <div class="border-round-2xl body-bg invoice_print"
    [ngClass]="$index < updateInvoiceType.length - 1 ? 'page-break-always' : '' ">
    @if(placeOrderObj){
    @if (type.id === 4) {
    <div class="flex justify-content-center align-items-center" id="branchLogo">
      <img [src]="branch_logo ? branch_logo : static_logo_url" alt="logo" width="100px" height="100px"
        (error)="onImageError()" loading="eager">
    </div>
    }
    @if (type.name == 'Customer') {
    <div class="flex justify-content-center align-items-center flex-column text-sm font-semibold py-2 text-center">
      <!-- Restaurant Branch Name -->
      <div>
        <!-- {{ userData.restaurant_name || '' }} -->
        {{ placeOrderObj.restaurant_branch?.name }}

      </div>

      <!-- Phone Numbers (one per line) -->
      @if (userData.phone_number || userData.phone_number2 || userData.phone_number3) {
      <div class="font-semibold flex flex-column items-center">
        @if (userData.phone_number) {
        <div>{{ userData.phone_number }}</div>
        }
        @if (userData.phone_number2) {
        <div>{{ userData.phone_number2 }}</div>
        }
        @if (userData.phone_number3) {
        <div>{{ userData.phone_number3 }}</div>
        }
      </div>
      }

      <!-- NTN Number -->
      @if (userData.ntn_number) {
      <div class="font-semibold">
        {{ userData.ntn_number }}
      </div>
      }
    </div>

    }

    <div class="flex justify-content-between text-sm font-semibold py-2">
      <div class="">{{ type.name }} Invoice
        @if(isOnGoing == true && type.id === 1) {<span>
          (OnGoing Order)</span>}
      </div>
      <div class=""></div>
    </div>

    @if(true){
    <div class="grid p-0 m-0 border-bottom-1 border-bottom-dashed">
      <div class="col-6">
        @if (true) {
        <div class="text-xs">
          <div>Name</div>
          @if (placeOrderObj.customer) {
          <div class="font-semibold">
            {{ placeOrderObj.customer.first_name || "" }}
            {{ placeOrderObj.customer.last_name || "" }}
          </div>
          }
        </div>
        }
      </div>
      <div class="col-6">
        <div class="text-xs">
          <div>Order Taker</div>
          @if (placeOrderObj.order_taker) {
          <div class="font-semibold">
            {{ placeOrderObj.order_taker.name || "N/A" }}
          </div>
          }
        </div>
      </div>

      <div class="col-6">
        <div class="text-xs">
          <div>Order Type</div>
          @if(placeOrderObj.order_type) {
          <div class="font-semibold">
            {{ placeOrderObj.order_type.type || "N/A" }}
          </div>
          }
        </div>
      </div>
      <div class="col-6">
        @if(placeOrderObj.table_no) {
        <div class="text-xs">
          <div>Table No</div>
          @if (placeOrderObj.table_no) {
          <div class="font-semibold">
            {{ placeOrderObj.table_no || "N/A" }}
          </div>
          }
        </div>
        }
      </div>

      <div class="col-6">
        <div class="text-xs">
          <div>Date</div>
          @if (placeOrderObj.order_date) {
          <div class="font-semibold">
            {{ placeOrderObj.order_date | date : "shortDate" }}
          </div>
          }
        </div>
      </div>
      <div class="col-6">
        <div class="text-xs">
          <div>Time</div>
          @if (placeOrderObj.order_date) {
          <div class="font-semibold">
            {{ placeOrderObj.order_date | date : "shortTime" }}
          </div>
          }
        </div>
      </div>

      <div *ngIf="!(type.name == 'Kitchen') " class="col-12">
        @if (placeOrderObj.customer.cell_num) {
        <div class="text-xs">
          <div>Contact No</div>
          <div class="font-semibold">
            {{ placeOrderObj.customer.cell_num }}
          </div>
        </div>
        }
      </div>

      <div *ngIf="type.name != 'Kitchen'" class="col-12">
        <div class="text-xs">
          <div>Payment Type</div>
          <div class="font-semibold">
            {{ placeOrderObj.payment_type.type }}
          </div>
        </div>
      </div>

      <div *ngIf="type.name != 'Kitchen'" class="col-12">
        <div class="text-xs">
          <div>Time Frame</div>
          <div class="font-semibold">
            {{
            placeOrderObj.time_frame_id === 1
            ? "Breakfast"
            : placeOrderObj.time_frame_id === 2
            ? "Lunch"
            : placeOrderObj.time_frame_id === 3
            ? "Dinner"
            : "Lunch"
            }}
          </div>
        </div>
      </div>
      <div class="col-12">
        @if (placeOrderObj.notes && placeOrderObj.notes.length > 0) {
        <div class="py-2 my-1 border-top-2 border-top-dashed border-clr">
          <div class="text-sm font-semibold line-height-3">
            Special Instruction
          </div>
          <div class="text-sm">{{ placeOrderObj.notes }}</div>
        </div>
        }
      </div>

      @if(type.name != 'Kitchen' && placeOrderObj.address &&
      placeOrderObj.order_type.type==='Delivery') {
      <div class="col-12">
        <div class="text-xs">
          <div>Address</div>
          <div class="font-semibold">
            {{ getAddress(placeOrderObj.address.address1) }}
          </div>
        </div>
      </div>
      }
    </div>
    }

    <div class="col-12 py-1">
      <div class="text-lg text-center font-semibold">
        <span>Order No {{ placeOrderObj.dailyorder_id }}</span>
      </div>
    </div>

    <div>
      <div class="flex justify-content-between text-sm font-semibold pb-3">
        <div class="">Items</div>
        @if (type.name != 'Kitchen') {
        <div class="">Price</div>
        } @else {
        <div class="">QTY</div>
        }
      </div>

      <div class="flex flex-column">
        @for (item of placeOrderObj.order_details; track $index) { @if
        (!(item.is_printed_in_kitchen === 1 && type.id == 1)) {
        @if(item.deal_details.length){
        <div class="border-bottom-1 border-bottom-dashed">
          <div class="flex w-full align-items-start fs-12 font-semibold">
            <div class="w-8">
              {{ item?.menu_name }}
              @if( item.menu_variation){
              <span>({{ item.menu_variation.name }})</span>
              }
            </div>
            <div class="text-end w-5 flex justify-content-end align-items-center">
              <div class="flex gap-1">
                <span class="font-normal fs-10">
                  ({{parseFloatPrice(item.quantity)}}x)
                </span>
              </div>
              &nbsp;{{
              type.name != "Kitchen"
              ? getPrice(item.price, item.quantity)
              : ""
              }}
            </div>
          </div>

          @for (dealMenu of item.deal_details; track $index) {
          <div class="flex w-full align-items-start fs-12 font-semibold flex-column">
            <div class="w-8">
              {{ parseFloatPrice(dealMenu.quantity) }} x
              {{ dealMenu?.menu_name }}
              @if( dealMenu.menu_variation){
              <span>({{ dealMenu.menu_variation.name }})</span>
              }
            </div>

            @if(dealMenu.order_detail_choice.length > 0 ) {
            <div>
              @for (choice of dealMenu.order_detail_choice; track $index)
              {
              <div class="flex w-full align-items-start font-normal fs-12 pl-2">

                <div class="w-10" style="white-space: nowrap;text-overflow: ellipsis;">{{ choice?.choice_name }}
                </div>
              </div>
              }
            </div>
            }
          </div>
          }@if(item.note && item.note.length > 0 && type.id == 1) {
          <div class="fs-10 pb-2">
            <span class="font-semibold">Note:</span>
            {{ item.note || "N/A" }}
          </div>
          }
        </div>
        } @else {
        <div class="border-bottom-1 border-bottom-dashed">
          <div class="flex w-full align-items-start fs-12 font-semibold">
            <div class="w-8">
              {{ item?.menu_name }}
              @if( item.menu_variation){
              <span>({{ item.menu_variation.name }})</span>
              }
            </div>
            <div class="text-end w-5 flex justify-content-end align-items-center">
              <div class="flex gap-1">
                <span class="font-normal">({{ parseFloatPrice(item.quantity) }}x)
                </span>
                <!-- <span *ngIf="type.name != 'Kitchen'" class="fw-300">
                        ({{ parseFloatPrice(item.price)}})
                      </span>  -->
              </div>
              &nbsp;{{
              type.name != "Kitchen"
              ? getPrice(item.price, item.quantity)
              : ""
              }}
            </div>
          </div>

          @if(item.order_detail_choice.length > 0 ) {
          <div [ngClass]="
                    item.note && item.note.length > 0 ? 'pb-1' : 'pb-1'
                  ">
            @for (choice of item.order_detail_choice; track $index) {
            <div class="flex w-full align-items-start fs-12">
              <div class="w-10" style="white-space: nowrap;text-overflow: ellipsis;">
                {{ choice?.choice_name }}
              </div>
            </div>
            }
          </div>
          } @if(item.note && item.note.length > 0 && type.id == 1) {
          <div class="fs-10 pb-2">
            <span class="font-semibold">Note:</span>
            {{ item.note || "N/A" }}
          </div>
          }
        </div>
        } } }
        @if(type.name != 'Kitchen'){
        <div class="border-top-1 border-top-dashed border-bottom-1 border-bottom-dashed flex flex-column gap-1">
          <div class="flex justify-content-between fs-12 font-semibold">
            <div>Items</div>
            @if(placeOrderObj.order_details){
            <div>{{ placeOrderObj.order_details.length }}</div>
            }
          </div>
          <div class="flex justify-content-between fs-12 font-semibold">
            <div>Subtotal</div>
            <div>{{currancy}}. {{ parseFloatPrice(placeOrderObj.sub_total) }}</div>
          </div>
          <div *ngIf="
                    parseFloatPrice(placeOrderObj.tax_percent) > 0 &&
                    userData.tax_include && (placeOrderObj.fbr_invoice_number || placeOrderObj.pra_invoice_number)"
            class="flex justify-content-between fs-12 font-semibold">
            <div>Tax {{parseFloatPrice(placeOrderObj.tax_percent)}}% (inclusive)</div>
            <div>{{currancy}}. {{ parseFloatPrice(placeOrderObj.tax_amount)}}</div>
          </div>
          <div *ngIf="parseFloatPrice(placeOrderObj.tax_percent) > 0 && !userData.tax_include "
            class="flex justify-content-between fs-12 font-semibold">
            <div>GST ({{ placeOrderObj.tax_percent }}%)</div>
            <div>{{currancy}}. {{ parseFloatPrice(placeOrderObj.tax_amount) }}</div>
          </div>
          @if (parseFloatPrice(placeOrderObj.discount_amount) > 0) {
          <div class="flex justify-content-between fs-12 font-semibold">
            <div>
              {{ getDiscountPerc( placeOrderObj.discount_amount, placeOrderObj.sub_total) }}
            </div>
            <div>{{currancy}}. {{ parseFloatPrice(placeOrderObj.discount_amount) }}</div>
          </div>
          } @if (parseFloatPrice(placeOrderObj.service_charge) > 0) {
          <div class="flex justify-content-between fs-12 font-semibold">
            <div>Service Charge</div>
            <div>{{currancy}}. {{ parseFloatPrice(placeOrderObj.service_charge) }}</div>
          </div>
          }
          @if (parseFloatPrice(placeOrderObj.delivery_charge) > 0) {
          <div class="flex justify-content-between fs-12 font-semibold">
            <div>Delivery Charge</div>
            <div>{{currancy}}. {{ parseFloatPrice(placeOrderObj.delivery_charge) }}</div>
          </div>
          }
          @if (+placeOrderObj.foodpanda_commission_percent>0) {
          <div class="flex justify-content-between fs-12 font-semibold">
            <div>Food Panda ({{(parseFloatPrice(placeOrderObj.foodpanda_commission_percent))}}%)</div>
            <div>{{currancy}}. {{parseFloatPrice(placeOrderObj.foodpanda_commission_amount)}}</div>
          </div>
          }
          <div class="flex justify-content-between fs-14 font-semibold">
            <div>Total</div>
            <div>{{currancy}}. {{ parseFloatPrice(placeOrderObj.total) }}</div>
          </div>
        </div>

        @if (placeOrderObj && (placeOrderObj.pra_invoice_number || placeOrderObj.fbr_invoice_number)) {
        <div class="col-12">
          <!-- PRA + FBR Section -->
          <div class="grid justify-content-center align-items-start mt-3 text-c enter">
            <!-- PRA Section -->
            @if (placeOrderObj.pra_invoice_number && type.id == 4) {
            <div class="col-12 md:col-6 flex flex-column align-items-center mb-3">
              <div class="flex align-items-center justify-content-center gap-2">
                <img src="/assets/images/pra.jpg" width="100" alt="PRA Logo" />
                <qrcode [qrdata]="placeOrderObj.pra_invoice_number" [elementType]="'img'" [width]="130"></qrcode>
              </div>
              <div class="text-center fs-12 font-semibold mt-2">
                PRA Invoice No: {{ placeOrderObj.pra_invoice_number }}
              </div>
            </div>
            }

            <!-- FBR Section -->
            @if (placeOrderObj.fbr_invoice_number && type.id == 4 && userData.restaurant_branch_idd !== 1309) {
            <div class="col-12 md:col-6 flex flex-column align-items-center mb-3">
              <div class="flex align-items-center justify-content-center gap-2">
                <img src="/assets/images/fbr.jpg" width="100" alt="FBR Logo" />
                <qrcode [qrdata]="placeOrderObj.fbr_invoice_number" [elementType]="'img'" [width]="130"></qrcode>
              </div>
              <div class="text-center fs-12 font-semibold mt-2">
                FBR Invoice No: {{ placeOrderObj.fbr_invoice_number }}
              </div>
            </div>
            }
          </div>

        </div>
        }
        @if(placeOrderObj && placeOrderObj.ajk_invoice_number && type.id == 4 && userData.restaurant_branch_idd ===
        1309) {
        <div class="flex flex-column align-items-center">
          <!-- QR + Logo Side by Side -->
          <div class="flex align-items-center justify-content-center gap-3">
            <qrcode [qrdata]="placeOrderObj.ajk_invoice_number" [elementType]="'img'" [width]="130">
            </qrcode>
            <img src="/assets/images/AJK_BW_JPG.jpg" width="100" alt="FBR Logo" />
          </div>

          <!-- Invoice Number Below -->
          <div class="text-center fs-12 font-semibold mt-2">
            AJK Invoice No: {{ placeOrderObj.ajk_invoice_number }}
          </div>
        </div>

        }

        <div class="col-12 pt-1">
          <div class="fs-18 text-center font-semibold">
            <span>{{ checkPaidStatus() }}</span>
          </div>
          <div *ngIf="userData.tax_include">
            <div class="fs-10 text-center font-semibold">
              <span>All prices are inclusive of Govt. taxes, Thank You!</span>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    }
  </div>
  }
</div>
}